import React from 'react';
import { Link } from 'react-router-dom';
import { VIRIDIA_LOGO_SRC } from './Brand';
import { navLinks } from '../data/navigation';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-ink-900" data-id="element-410" data-mp="3mhj9y0u510od">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8" data-id="element-411" data-mp="3mfyfeb7tphqi">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-412" data-mp="3hj803q3ueq65">
          <div className="max-w-sm" data-id="element-413" data-mp="3dhe2xrsuw4aq">
            <img src={VIRIDIA_LOGO_SRC} alt="Viridia Analytics" className="h-[72px] w-auto" data-id="element-414" data-mp="3difoiq7i096p" />
            <p className="mt-5 text-sm leading-relaxed text-white/50" data-id="element-415" data-mp="33if0ws2lj6wp">
              Response systems for lead-driven businesses.
            </p>
          </div>

          <nav aria-label="Footer" className="md:text-right" data-id="element-416" data-mp="2yleyqs8vaoav">
            <ul className="flex flex-col gap-3 md:items-end" data-id="element-417" data-mp="11q8zrvzaprwr">
              {[...navLinks, {
              label: 'Book the Audit',
              to: '/book'
            }].map(link => <li key={link.to} data-id="element-418" data-mp="wqeatxz2zcec">
                  <Link to={link.to} className="rounded text-sm text-white/70 transition-colors hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-419" data-mp="15qlsq69wrunr">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-420" data-mp="1ohmpqorgxg4o">
          <a href="https://viridiaanalytics.com" className="rounded text-white/70 transition-colors hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-421" data-mp="1tf4pbojlij00">
            viridiaanalytics.com
          </a>
          <p className="text-white/35" data-id="element-422" data-mp="27gh4hxqxmgku">Copyright 2026 Viridia Analytics</p>
        </div>
      </div>
    </footer>;
}